import { getCard } from '../../../api-v2/queries/card-queries';
import { flowsListQuery } from '../../../api-v2/queries/flows-list-query';
import { playbookQuery, playbooksListQuery } from '../../../api-v2/queries/playbook-queries';
import userListQuery from '../../../api-v2/queries/user-list-query';

export const playbooksPageLoader = (queryClient) => async (opts) => {
  const url = new URL(opts.request.url);
  const archived = url.searchParams.get('archived') === 'true';
  await queryClient.ensureQueryData(playbooksListQuery({ archived }));

  return { archived };
};

export const editPlaybookPageLoader = (queryClient) => async (opts) => {
  const { playbookId } = opts.params;
  await queryClient.ensureQueryData(playbookQuery({ playbookId, groupView: true }));

  return { playbookId };
};

export const playbookTaskPageLoader = (queryClient) => async (opts) => {
  const { playbookId, flowId } = opts.params;
  await queryClient.ensureQueryData(userListQuery());
  await queryClient.ensureQueryData(flowsListQuery());
  await queryClient.ensureQueryData(playbookQuery({ playbookId, groupView: true }));
  await queryClient.ensureQueryData(getCard({ cardId: flowId }));

  return { playbookId, flowId };
};

export const playbookTaskGroupPageLoader = (queryClient) => async (opts) => {
  const { playbookId, flowGroupId } = opts.params;
  await queryClient.ensureQueryData(playbookQuery({ playbookId, groupView: true }));
  await queryClient.ensureQueryData(getCard({ cardId: flowGroupId }));

  return { playbookId, flowGroupId };
};
